import {graphql, useFragment} from 'react-relay'

import type {Build} from '../services/rest'
import {BuildStatusType} from '../types'

import type {buildStatusTypeFragment$key} from './__generated__/buildStatusTypeFragment.graphql'

export const getBuildStatusTypeFromBuild = (
  build: Pick<Build, 'status' | 'state' | 'canceledInfo' | 'failedToStart'> | null | undefined,
): BuildStatusType => {
  const {status, state: buildState, canceledInfo, failedToStart} = build || {}

  if (canceledInfo != null && buildState !== 'running') {
    return BuildStatusType.CANCELED
  } else if (failedToStart === true) {
    return BuildStatusType.FAILURE
  } else if (buildState === 'queued') {
    return BuildStatusType.QUEUED
  } else {
    const isGreen = status == null || status === 'SUCCESS'
    return isGreen ? BuildStatusType.SUCCESS : BuildStatusType.FAILURE
  }
}

const statusTypeFragment = graphql`
  fragment buildStatusTypeFragment on Build {
    status
    state
    canceledInfo {
      __typename
    }
    failedToStart
  }
`
export function useBuildStatusTypeFromBuild(key: buildStatusTypeFragment$key | null) {
  const build = useFragment(statusTypeFragment, key)
  return getBuildStatusTypeFromBuild(build)
}
